<template>
  <div class="cupom-editar">
    <PmwTopProgress :start="loadingData" :done="!loadingData" color="#53B483" />
    <SidebarLayout3
      :breadcrumb="breadcrumb"
      :pageTitle="!isLots ? titleCouponSingle : titleCouponLots"
      :separateTitle="true"
    >
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading class="page-actions--heading">
            Ações da página
          </Heading>

          <!-- CRIAR -->
          <Button
            v-if="!isLots"
            :disabled="disableSaveButton"
            :tooltipText="
              fields.tipoValor.value === 3
                ? 'Necessário preencher o nome do cupom e a quantidade de noites grátis'
                : 'Necessário  preencher o nome do cupom e o valor de desconto.'
            "
            class="page-actions--button"
            tooltipMinWidth="230"
            @click="createUpdateCoupon"
          >
            {{ saveButtonLabel }}
          </Button>
          <Button
            v-else
            :disabled="disableSaveButtonLots"
            tooltipText="Preencha todos os campos"
            class="page-actions--button"
            @click="createUpdateCoupon"
          >
            {{ saveButtonLabel }}
          </Button>

          <!-- CANCELAR -->
          <Button
            :link="`/cupons-desconto/lista`"
            :disabled="uploadingCsv"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            Cancelar
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>

          <RandomText :terms="tips.first" />
          <RandomText :terms="tips.second" />
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO PRINCIPAL -->
      <template #content>
        <!-- EXIBIÇÃO -->
        <div class="fieldset exibition">
          <b-row align-v="center">
            <b-col>
              <Heading class="heading__margin-title" level="2">
                Tipo de cupom

                <p class="heading__margin-subtitle mt-3">
                  <!-- Avulso -->
                  <span v-if="!isLots">
                    Cupons são códigos com regras específicas que aplicados
                    permitem descontos para os hóspedes e parceiros.
                  </span>

                  <!-- Em massa -->
                  <span v-else>
                    Cupons em massa permitem que você crie inúmeros cupons com
                    as mesmas regras. Ex: BLACKFRIDAY1, BLACKFRIDAY2
                  </span>
                </p>
              </Heading>
            </b-col>
          </b-row>

          <!-- TIPO CUPOM CUPOM/CUPONS EM MASSA -->
          <b-row
            v-if="!couponId"
            align-v="center"
            class="fields-row fields-row__mb50"
          >
            <b-col cols="6">
              <div class="status-fields">
                <InputRadio
                  v-model="isLots"
                  :checked="!isLots"
                  :inputValue="false"
                  label="Cupom"
                  name="tipoCupomSelecionado"
                  class="status-fields--input"
                />
                <InputRadio
                  v-model="isLots"
                  :checked="isLots"
                  :inputValue="true"
                  label="Cupons em massa"
                  name="tipoCupomSelecionado"
                  class="status-fields--input"
                />
              </div>
            </b-col>
          </b-row>

          <Heading v-if="!isLots" class="heading__margin-title" level="2">
            Configure seu cupom

            <p v-if="wasUsed" class="heading__advice">
              Não é possível alterar valores deste cupom, pois o mesmo já foi
              utilizado em reserva(s).
            </p>
          </Heading>

          <Heading v-else class="heading__margin-title" level="2">
            Exibição

            <p v-if="wasUsed" class="heading__advice">
              Não é possível alterar valores deste cupom, pois o mesmo já foi
              utilizado em reserva(s).
            </p>
          </Heading>

          <b-row align-v="center" class="fields-row">
            <b-col cols="3">
              <!-- CÓDIGO -->
              <ValidationProvider
                vid="cupom"
                mode="eager"
                rules="required"
                v-slot="v"
              >
                <FormInput
                  v-model.trim="fields.cupom"
                  :error="v.invalid && v.touched"
                  :showErrorFeedbackMessage="true"
                  :infoIcon="true"
                  :feedbackMessage="v.errors[0]"
                  :maxlength="20"
                  :disabled="wasUsed"
                  :infoText="
                    !isLots
                      ? 'Este código não pode ser repetido no sistema.'
                      : 'Este nome do grupo não pode ser repetido no sistema.'
                  "
                  :label="
                    !isLots ? 'Código do cupom' : 'Nome do grupo de cupons'
                  "
                  name="cupom"
                  placeholder="Insira o nome"
                  @input="validateName"
                />
              </ValidationProvider>
            </b-col>

            <!-- TARIFAS -->
            <b-col cols="3">
              <FormSelectCoupon
                v-model="fields.tarifas"
                :options="ratesSelectOptions"
                :toggleAll="showToggleAllInput"
                :wasUsed="wasUsed"
                :infoIcon="true"
                :search="true"
                :multiple="true"
                :showCounter="isLots"
                :maxQuantitySelection="isLots ? maxRatesSelection : null"
                :infoText="tariffTooltip"
                :tooltipMinWidth="isLots ? '250' : '170'"
                labelKey="descricao"
                valueKey="codigo"
                name="tarifas"
                label="Tarifas aplicáveis"
                placeholder="Selecione"
                loadOnDemand
                @search="searchHandler"
              >
              </FormSelectCoupon>
              <p v-if="rateStatus" class="alert--inactivatedRates">
                Uma ou mais tarifas aplicáveis a esse cupom não estão mais
                ativas.
              </p>
            </b-col>

            <!-- ATIVO/INATIVO -->
            <b-col cols="6">
              <div class="status-fields">
                <InputRadio
                  v-model="fields.ativo"
                  :inputValue="true"
                  :checked="fields.ativo"
                  label="Ativo"
                  name="status"
                  class="status-fields--input"
                />
                <InputRadio
                  v-model="fields.ativo"
                  :inputValue="false"
                  :checked="!fields.ativo"
                  label="Inativo"
                  name="status"
                  class="status-fields--input"
                />
              </div>
              <p class="status-feedback">{{ statusFeedback }}</p>
            </b-col>
          </b-row>

          <b-row align-v="center" class="fields-row">
            <!-- TIPO DESCONTO -->
            <b-col cols="3">
              <FormSelect
                v-model="fields.tipoValor"
                :options="discountTypeSelectOptions"
                :disabled="wasUsed"
                name="tipoValor"
                label="Tipo de desconto"
                placeholder="Selecione"
              />
            </b-col>
            <!-- VALOR DESCONTO / NOITES GRÁTIS -->
            <b-col cols="3" class="position__relative">
              <FormInput
                v-if="fields.tipoValor.value === 3"
                key="free-stays"
                v-model="fields.valor"
                :disabled="wasUsed"
                name="noitesGratis"
                label="Quantidade de noites grátis"
                placeholder="0"
                sufix="noites"
              />
              <FormInput
                v-else
                key="discount-field"
                v-model="fields.valor"
                :sufix="discountSufix"
                :disabled="wasUsed"
                type="number"
                name="valor"
                label="Valor do desconto"
                :placeholder="fields.tipoValor.value === 1 ? '0' : '0,00'"
              />
            </b-col>
            <!-- TIPO UTILIZAÇÃO / SOMENTE QUANDO FOR NOITES GRÁTIS-->
            <transition name="fade-medium">
              <b-col v-if="fields.tipoValor.value === 3" cols="3">
                <FormSelect
                  v-model="fields.tipoNoiteGratis"
                  :options="typeOfUseOptions"
                  name="tipoNoiteGratis"
                  label="Tipo de utilização"
                  placeholder="Selecione"
                />
              </b-col>
            </transition>
          </b-row>

          <b-row>
            <b-col :class="{ disabled: wasUsed }" cols="3">
              <InputCheckbox
                v-model="fields.centralReservas"
                :checked="fields.centralReservas"
                :infoIcon="true"
                tooltipMinWidth="200"
                infoText="Define se o cupom é público ou se ele será usado somente na central de reservas."
                label="Exclusivo Central de Reservas"
              />
            </b-col>
          </b-row>
        </div>

        <!-- SE É LOTES E CRIAÇÃO -->
        <b-row v-if="isLots && isCreation" class="row">
          <b-col cols="4">
            <InputAddImage
              v-model="uploadedFile"
              :title="'Planilha de códigos'"
              :max-size="600"
              accept=".csv"
              backgroundImage=""
              textBox="Arraste aqui a planilha"
              class="input-file"
              @changeFile="validateCsvExtension"
            />
            <Heading
              class="heading__margin-subtitle"
              style="margin-top: 10px"
              level="3"
            >
              Apenas arquivos .csv com limite de 2.500 linhas.
            </Heading>
          </b-col>
        </b-row>

        <SeparateLine :left="-10" :right="-10" />

        <!-- CONFIGURAÇÃO -->
        <div :class="{ disabled: wasUsed }" class="fieldset setup">
          <Heading class="heading__margin-title mb-4" level="3">
            Regras para o uso
          </Heading>

          <b-row class="fields-row">
            <!-- TIPO DESCONTO -->
            <b-col cols="3">
              <FormDatepicker
                v-model="fields.periodoReserva"
                :vcalendarOptions="{
                  isRange: true
                }"
                :minDate="minDate"
                label="Período da reserva"
                placeholder="dd/mm/aaaa - dd/mm/aaaa"
              />
            </b-col>

            <!-- VALOR DESCONTO / NOITES GRÁTIS -->
            <b-col cols="3" class="position__relative">
              <FormDatepicker
                v-model="fields.periodoHospedagem"
                :vcalendarOptions="{
                  isRange: true
                }"
                :minDate="minDate"
                label="Período da hospedagem"
                placeholder="dd/mm/aaaa - dd/mm/aaaa"
              />
            </b-col>
          </b-row>

          <b-row class="fields-row mb-0">
            <!-- VALOR MÍNIMO -->
            <b-col cols="3">
              <FormInput
                v-model="fields.valorMinimoQuartos"
                :infoIcon="true"
                infoText="Se o valor dos quartos for menor que o selecionado, o cupom não será aplicado."
                name="valorMinimoQuartos"
                label="Valor mínimo dos quartos"
                placeholder="0,00"
                sufix="R$"
                type="number"
              />
            </b-col>

            <!-- MÍNIMO DE NOITES -->
            <b-col cols="3">
              <FormInput
                v-model="fields.minimoNoites"
                name="minimoNoites"
                label="Mín. de noites"
                placeholder="0"
                sufix="noites"
                type="number"
              />
            </b-col>

            <!-- MÍNIMO DE QUARTOS -->
            <!-- infoText="Este texto está faltando, solcitar para UX" -->
            <b-col cols="3">
              <FormInput
                v-model="fields.minimoQuartos"
                :infoIcon="false"
                name="minimoQuartos"
                label="Míni. de quartos na reserva"
                placeholder="0"
                sufix="quartos"
                type="number"
              />
            </b-col>
          </b-row>

          <SeparateLine :left="-10" :right="-10" />

          <div :class="{ disabled: wasUsed }" class="fieldset exibition">
            <Heading class="heading__margin-title" level="3">
              Quer limitar a quantidade de usos?
              <p class="heading__margin-subtitle mt-3">
                Defina quantas vezes um cupom pode ser usado antes de expirar.
              </p>
            </Heading>
          </div>

          <b-row align-v="center" class="fields-row mt-4">
            <b-col cols="8">
              <div class="status-fields">
                <InputRadio
                  v-model="fields.tipoLimiteUso"
                  :inputValue="1"
                  :checked="fields.tipoLimiteUso === 1"
                  label="Não limitar"
                  name="tipoLimiteUso"
                  class="status-fields--input"
                />

                <InputRadio
                  v-model="fields.tipoLimiteUso"
                  :inputValue="2"
                  :checked="fields.tipoLimiteUso === 2"
                  label="Limitar por reserva"
                  name="tipoLimiteUso"
                  class="status-fields--input"
                />

                <InputRadio
                  v-model="fields.tipoLimiteUso"
                  :inputValue="3"
                  :checked="fields.tipoLimiteUso === 3"
                  label="Limitar por noites"
                  name="tipoLimiteUso"
                  class="status-fields--input"
                />

                <InputRadio
                  v-if="!isLots"
                  v-model="fields.tipoLimiteUso"
                  :inputValue="4"
                  :checked="fields.tipoLimiteUso === 4"
                  label="Limitar por Pessoa"
                  name="tipoLimiteUso"
                  class="status-fields--input"
                />
              </div>
            </b-col>
          </b-row>

          <b-row v-if="fields.tipoLimiteUso !== 1" class="fields-row mb-0">
            <b-col cols="3">
              <FormInput
                v-model="fields.quantidadeMaximaUso"
                :sufix="
                  $options.filters.pluralizer(
                    fields.quantidadeMaximaUso,
                    fields.tipoLimiteUso === 3
                      ? 'noite | noites'
                      : 'reserva | reservas',
                    true
                  )
                "
                :infoIcon="fields.tipoLimiteUso === 4"
                tooltipMinWidth="350"
                infoText="Permite que cada pessoa (identificada por CPF/Passaporte) utilize o cupom até a quantidade de vezes configurado, considerando reservas confirmadas."
                name="valorMinimoQuartos"
                label="Quantidade de Usos Permitidos"
                placeholder="200"
                type="number"
                @blur="onlyPositiveNumbers"
              />
            </b-col>
          </b-row>
        </div>
        <!-- BOTÕES DE AÇÃO -->
        <b-row>
          <b-col class="page-actions--footer">
            <!-- CANCELAR -->
            <Button
              :link="`/cupons-desconto/lista`"
              :disabled="uploadingCsv"
              element="router-link"
              class="page-actions--button"
              layout="outline"
              size="large"
            >
              Cancelar
            </Button>

            <!-- CRIAR -->
            <Button
              v-if="!isLots"
              class="page-actions--button"
              :disabled="disableSaveButton"
              :tooltipText="
                fields.tipoValor.value === 3
                  ? 'Necessário preencher o nome do cupom e a quantidade de noites grátis'
                  : 'Necessário  preencher o nome do cupom e o valor de desconto.'
              "
              tooltipMinWidth="230"
              size="large"
              @click="createUpdateCoupon"
            >
              {{ saveButtonLabel }}
            </Button>
            <Button
              v-else
              :disabled="disableSaveButtonLots"
              tooltipText="Preencha todos os campos"
              class="page-actions--button"
              size="large"
              @click="createUpdateCoupon"
            >
              {{ saveButtonLabel }}
            </Button>
          </b-col>
        </b-row>
      </template>
    </SidebarLayout3>

    <!-- ALERTA DE CARREGAMENTO de CSV -->
    <AlertModal v-model="showUploadDelayAlert" title="Importante" lockOverlay>
      <template #text>
        <!-- MENSAGEM DE SUCESSO CASO SEJA CRIAÇÃO -->
        <span v-if="isCreation">
          A criação dos cupons pode demorar<br />
          alguns minutos para ser processada.
        </span>
        <!-- MENSAGEM DE SUCESSO CASO SEJA EDIÇÃO -->
        <span v-else>
          A edição dos cupons pode demorar<br />
          alguns minutos para ser processada.
        </span>
        <br />
        Você pode continuar navegando tranquilamente <br />
        que te avisaremos assim que finalizar.
      </template>
      <template #actions>
        <Button size="large" @click="goToList()">
          Ir para listagem
        </Button>
      </template>
    </AlertModal>

    <!-- ALERTA DE NENHUMA TARIFA SELECIONADA -->
    <AlertModal
      v-model="showAlertModal"
      title="Importante"
      icon="bulb"
      @alert-modal-confirm="saveCoupon"
    >
      <template #text>
        Você não selecionou nenhuma tarifa e o <br />cupom será aplicavel em
        todas. Deseja continuar?
      </template>
    </AlertModal>

    <!-- ALERTA DE FORMATO DE ARQUIVO INVÁLIDO -->
    <AlertModal
      v-model="showInvalidFileAlertModal"
      title="Formato do arquivo inválido"
      icon="x-icon"
      cancelButtonText=""
      confirmButtonText="Voltar e conferir"
      @alert-modal-confirm="clearUploadedFile"
    >
      <template #text>
        <p class="text-modal">
          Verifique a formatação e o tipo de arquivo e tente novamente.
        </p>
        Somente arquivos .CSV com tamanho <br />
        máximo de 600mb. são permitidos.
      </template>
    </AlertModal>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import debounce from 'lodash.debounce'
import { formatDate } from '@/helpers/date'

/** vee-validate add the required rule */
extend('required', {
  ...required,
  message: 'Campo obrigatório'
})

import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import RandomText from '@/components/_base/patterns/RandomText'
import Heading from '@/components/_base/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import FormInput from '@/components/_base/elements/FormInput'
import FormSelect from '@/components/_base/elements/FormSelect'
import FormSelectCoupon from '@/components/_base/elements/FormSelectCoupon/index'
import InputRadio from '@/components/_base/elements/InputRadio'
import InputCheckbox from '@/components/_base/elements/InputCheckbox'
import AlertModal from '@/components/_base/patterns/AlertModal'
import SeparateLine from '@/components/_base/patterns/SeparateLine'
import FormDatepicker from '@/components/_base/elements/FormDatepicker'
import InputAddImage from '@/components/_base/patterns/InputAddImage'
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'

export default {
  name: 'EditCoupon',
  components: {
    ValidationProvider,
    SidebarLayout3,
    SidebarBlock,
    RandomText,
    Button,
    Heading,
    FormInput,
    FormSelect,
    FormSelectCoupon,
    InputRadio,
    InputCheckbox,
    AlertModal,
    SeparateLine,
    FormDatepicker,
    InputAddImage,
    PmwTopProgress
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Letsbook'
        },
        {
          label: 'Cupons de desconto',
          url: '/cupons-desconto/lista',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ],
      pageTitle: 'Cadastrar cupom',

      tips: {
        first: [
          {
            paragraph1:
              'O sistema <strong>diferencia</strong> a acentuações e espaços.<br> Se não colocar o acento ou espaço, o cupom não é identificado.',
            paragraph2: 'Exemplos que terão resultados diferentes:',
            paragraph3:
              '<strong>Volte pra cá / Voltepraca</strong><br> <strong>Voltei, quero. / Voltei quero.</strong>'
          }
        ],
        second: [
          {
            paragraph1: 'Algumas sugestões:',
            paragraph3:
              '<strong>VOLTEI</strong><br><strong>FIQUE</strong><br><strong>NIVER10</strong><br><strong>10OFF</strong><br><strong>FIQUE3PAGUE2</strong>'
          }
        ]
      },

      showAlertChip: false,
      AlertChipMessage: 'Criado com sucesso.',
      fields: {
        tipoCupomSelecionado: '',
        cupom: '',

        tarifas: [],
        ativo: true,
        tipoValor: { text: 'Absoluto', value: 2 },
        valor: null,
        centralReservas: false,

        valorMinimoQuartos: null,
        minimoNoites: null,
        minimoQuartos: null,

        quantidadeMaximaUso: null,
        tipoLimiteUso: 1,

        tipoNoiteGratis: {
          text: 'Primeiras noites',
          value: 1
        },
        periodoHospedagem: null,
        periodoReserva: null
      },
      value: '',
      ratesId: [] /** Listagem de ids das tarifas */,
      ratesSelectOptions: [] /** Listagem de tarifas formatado */,
      rateStatus: false /** Status das tarifas */,
      discountTypeSelectOptions: [
        {
          text: 'Percentual',
          value: 1
        },
        {
          text: 'Absoluto',
          value: 2
        },
        {
          text: 'Noites Grátis',
          value: 3
        }
      ],
      typeOfUseOptions: [
        {
          text: 'Primeiras noites',
          value: 1
        },
        {
          text: 'Últimas noites',
          value: 2
        },
        {
          text: 'Noites de maior valor',
          value: 3
        },
        {
          text: 'Noites de menor valor',
          value: 4
        }
      ],
      minDate: new Date(),
      showAlertModal: false,
      showInvalidFileAlertModal: false,
      saveButtonLabel: 'Criar cupom',
      isCreation: true /** Se é a tela de criação */,
      couponId: null,
      uploadedFile: null,
      routeType: '',
      isLots: '' /** Se é criação ou edição de cupons em lote */,
      titleCouponSingle: '' /** Exibe o título de cupons únicos */,
      titleCouponLots: '' /** Exibe o título de cupons em massa*/,
      invalidInputedName: false /** Flag que valida se o nome já está utilizado */,
      uploadingCsv: false /** True se o csv está sendo carregado */,
      showUploadDelayAlert: false /** Modal de alerta para carregamento do csv */,
      loadingData: false,
      searchResultLength: 0 /** Quantidade de resultados retornados na busca */,
      maxRatesSelection: 600 /** Limite de tarifas que podem ser selecioinadas */
    }
  },

  computed: {
    statusFeedback() {
      return this.fields.ativo
        ? 'Os usuários poderão usar o cupom nas reservas.'
        : 'Os usuários não poderão usar o cupom nas reservas.'
    },
    disableSaveButton() {
      return !this.fields.cupom || !this.fields.valor || this.invalidInputedName
    },
    disableSaveButtonLots() {
      return (
        !this.fields.cupom /** se não possui nome */ ||
        !this.fields.valor /** se não possui valor */ ||
        (!this.uploadedFile &&
          this.isCreation) /** se não foi feito upload e é criação */ ||
        this.invalidInputedName /** Se o nome já foi utilizado */ ||
        this.uploadingCsv /** Se o csv está sendo carregado */ ||
        (this.fields.tipoValor.value === 3 &&
          !this.fields
            .tipoNoiteGratis) /** Se for tipo Noites grátis, é preciso preencher o tipo de noite grátis */
      )
    },
    discountSufix() {
      return this.fields.tipoValor.value === 1 ? '%' : 'R$'
    },
    wasUsed() {
      return this.fields.quantidadeUtilizada > 0 || this.fields.possuiReservas
    },

    /** Retorna todas as tarifas de todos os hotéis */
    allHotelsRates() {
      return this.ratesSelectOptions.flatMap((hotel) => hotel.tarifas)
    },

    /** Quantidade total de tarifas de todos hotéis */
    totalRatesLength() {
      return this.allHotelsRates.length
    },

    /** Quantidade de tarifas ativas de todos hotéis */
    allActiveRates() {
      return this.allHotelsRates.filter((rate) => rate.ativo)
    },

    /** Quantidade de tarifas ativas de todos hotéis */
    totalActiveRatesLength() {
      return this.allActiveRates.length
    },

    /** Apresenta o checkbox para selecionar todas as tarifas do select */
    showToggleAllInput() {
      if (!this.maxRatesSelection) return true

      /** Se tem filtro ativo */
      if (this.searchResultLength) {
        /** Se a soma dos itens selecionados com o resultado do filtro for menor ou igual ao limite */
        return (
          this.searchResultLength + this.fields.tarifas.length <=
          this.maxRatesSelection
        )
      }

      return this.totalActiveRatesLength <= this.maxRatesSelection
    },

    /** Retorna se todas as tarifas estão selecionadas */
    allRatesChecked() {
      return (
        this.totalRatesLength > 0 &&
        this.totalRatesLength === this.fields.tarifas.length
      )
    },

    /** Mensagem da tooltip da seleção de tarifas */
    tariffTooltip() {
      return this.isLots
        ? 'O limite para aplicação do cupom é de 600 tarifas. Se nenhuma tarifa for selecionada manualmente, o cupom será aplicável a todas as tarifas existentes, desde que não ultrapassem o limite de 600. Em ambos os casos (seleção manual ou automática), se o total de tarifas exceder 600, as alterações não serão salvas.'
        : 'Caso nenhuma tarifa seja selecionada, o cupom será aplicável a todas as tarifas.'
    }
  },

  watch: {
    /** Detectar quando o limite de uso do cupom mudar */
    'fields.tipoLimiteUso': {
      handler: function(newVal) {
        /** Se for do tipo "ilimitado", limpar o campo da quantidade máxima de uso */
        if (newVal === 1) this.fields.quantidadeMaximaUso = null
      },
      deep: true
    },

    isLots(newVal) {
      if (newVal) {
        this.maxRatesSelection = 600

        if (this.fields.tarifas.length > this.maxRatesSelection) {
          this.fields.tarifas = []
        }

        /** Desmarcar a opção "Limite por pessoa" */
        if (this.fields.tipoLimiteUso === 4) {
          this.fields.tipoLimiteUso = 1
        }
      } else {
        this.maxRatesSelection = null
      }
    }
  },

  async created() {
    this.loadingData = true

    /** Verifica se é uma edição pelo parâmetro da url */
    this.couponId = this.$route.params.id
    this.routeType = +this.$route.query.tipo

    /** Título da página */
    this.titleCouponSingle = 'Cadastrar cupom'
    this.titleCouponLots = 'Cadastrar cupons em massa'

    /** Verifica o tipo de cupom que será cadastrado
     * Se this.routeType == 1 trata-se de um cupom simples senão,
     * trata-se de um cupom em massa */

    if (+this.routeType === 2) {
      this.isLots = true
    } else {
      this.isLots = false
      this.maxRatesSelection = null
    }

    const cupomValidarEdicao =
      !this.isLots && this.couponId ? this.couponId : ''
    const agrupadorValidarEdicao =
      this.isLots && this.couponId ? this.couponId : ''

    await this.$coupon
      .getAvailableRates(cupomValidarEdicao, agrupadorValidarEdicao, '')
      .then((response) => {
        /** Função que formata os dados para passar para o seletor de tarifas */
        this.applySelectDataFormat(response.data)
        this.loadingData = false
      })

    /** Se possuí id na url é edição */
    if (this.couponId) {
      this.isCreation = false
      this.saveButtonLabel = 'Salvar alterações'

      /** Títulos da página */
      this.titleCouponSingle = 'Editar cupom'
      this.titleCouponLots = 'Editar cupons em massa'

      /** Se não é cupom em massa */
      if (!this.isLots) {
        this.$coupon.get(this.couponId).then((response) => {
          this.filterRateOptionsForSelection(response.data.tarifas)

          /** Adequa os dados para o formato do componente datatable  */
          this.fields = response.data

          /** Seta o título da página */
          this.pageTitle = this.fields.cupom

          /** Seta o passo atual do breadcrumb */
          this.breadcrumb.push({
            label: this.pageTitle,
            url: `/cupons-desconto/editar/${this.fields.codigo}`,
            isSpa: true /** se deve ser um link para o site novo ou antigo  */
          })

          this.fillEditionFields(response)
        })
      } else {
        this.$coupon.getLots(this.couponId).then((response) => {
          this.filterRateOptionsForSelection(response.data.tarifas)

          /** Adequa os dados para o formato do componente datatable  */
          this.fields = response.data

          this.$set(this.fields, 'cupom', response.data.nome)

          /** Seta o título da página */
          this.pageTitle = this.fields.cupom

          /** Seta o passo atual do breadcrumb */
          this.breadcrumb.push({
            label: this.pageTitle,
            url: `/cupons-desconto/editar/${this.fields.codigo}`,
            isSpa: true /** se deve ser um link para o site novo ou antigo  */
          })

          this.fillEditionFields(response)
        })
      }
    } else {
      this.breadcrumb.push({
        label: 'Cadastrar cupom',
        url: '/cupons-desconto/novo',
        isSpa: true /** se deve ser um link para o site novo ou antigo  */
      })
    }
  },
  methods: {
    /** Remove da listagem as tarifas inativas que não estão vinculadas ao cupom */
    filterRateOptionsForSelection(rates) {
      this.ratesSelectOptions.forEach((hotel) => {
        hotel.options = hotel.options.filter(
          (rate) => rate.ativo || rates.includes(rate.codigo)
        )

        hotel.tarifas = hotel.options
      })
    },

    /**
     * Callback do evento de busca do select de tarifaas
     * @param {object[]} results Array de resultados encontrados
     */
    searchHandler(results) {
      this.searchResultLength = results.flatMap((hotel) => hotel.options).length
    },
    /** Limpa o arquivo carregado para upload */
    clearUploadedFile() {
      this.uploadedFile = null
    },
    /** Recebe o arquivo de cupons e verifica se é um arquivo .csv */
    validateCsvExtension(event) {
      if (!event.name.includes('.csv')) {
        this.showInvalidFileAlertModal = true
      }
    },
    /** Valida se o nome inserido está livre para uso */
    validateName: debounce(function() {
      if (!this.isLots) {
        this.validateCouponName()
        return
      }

      this.validateGroupName()
    }, 500),
    /** Valida se o código do cupom já está em uso */
    validateCouponName() {
      this.$coupon.verifyCoupon(this.fields.cupom).then((response) => {
        const { cupomDisponivel } = response.data

        if (!cupomDisponivel) {
          this.$_veeObserver.refs.cupom.setErrors([
            'Chave já utilizada no sistema'
          ])

          this.invalidInputedName = true
        } else {
          this.invalidInputedName = false
        }
      })
    },
    /** Valida se o nome do grupo já está em uso */
    validateGroupName() {
      this.$coupon
        .verifyGroup(this.fields.cupom, this.$route.params.id)
        .then((response) => {
          const { agrupadorDisponivel } = response.data

          if (!agrupadorDisponivel) {
            this.$_veeObserver.refs.cupom.setErrors([
              'Chave já utilizada no sistema'
            ])

            this.invalidInputedName = true
          } else {
            this.invalidInputedName = false
          }
        })
    },
    createUpdateCoupon() {
      if (!this.fields.tarifas || this.fields.tarifas.length === 0) {
        this.showAlertModal = true
        return
      }

      this.saveCoupon()
    },

    formatRatesToSave(tarifas) {
      if (tarifas.length && !this.allRatesChecked) {
        tarifas = tarifas.map((item) => item.codigo)
      } else {
        /** Se nenhuma tarifa for selecionada, selecionar todas */
        tarifas = []
      }

      return tarifas
    },

    async saveCoupon() {
      /** Se não for cupom em massa */
      if (!this.isLots) {
        const data = JSON.parse(JSON.stringify(this.fields))

        data.valor = +this.fields.valor
        data.valorMinimoQuartos = this.fields.valorMinimoQuartos
          ? +this.fields.valorMinimoQuartos
          : this.fields.valorMinimoQuartos
        data.minimoNoites = this.fields.minimoNoites
          ? +this.fields.minimoNoites
          : this.fields.minimoNoites
        data.minimoQuartos = this.fields.minimoQuartos
          ? +this.fields.minimoQuartos
          : this.fields.minimoQuartos
        data.quantidadeMaximaUso = this.fields.quantidadeMaximaUso
          ? +this.fields.quantidadeMaximaUso
          : this.fields.quantidadeMaximaUso
        data.tipoValor = this.fields.tipoValor.value
        data.tipoNoiteGratis = this.fields.tipoNoiteGratis?.value

        /** Padroniza os períodos para o formato aceito pela API */
        data.reservaInicio = data.periodoReserva?.start
        data.reservaFim = data.periodoReserva?.end
        data.dataChegada = data.periodoHospedagem?.start
        data.dataSaida = data.periodoHospedagem?.end

        this.showAlertModal = false

        /** Verificar se há alguma tarifa selecionada */
        data.tarifas = this.formatRatesToSave(data.tarifas)

        /** Adicionar as tarifas selecionadas inativas (que não estão presentes na listagem) */

        /** Se for um cadastro de um novo cupom */
        if (this.isCreation) {
          await this.$coupon
            .create(data)
            .then((response) => {
              if (response.status === 200) {
                this.$bus.$emit('show-alert-chip', {
                  message: 'Cupom criado com sucesso'
                })

                setTimeout(() => {
                  this.$router.push({
                    path: '/cupons-desconto/lista'
                  })
                }, 1000)
              }
            })
            .catch((error) => {
              this.$bus.$emit('show-alert-chip', {
                message: error.messages
              })
            })
        } else {
          this.$coupon
            .update(data)
            .then((response) => {
              if (response.status === 200) {
                this.$bus.$emit('show-alert-chip', {
                  message: 'Cupom atualizado com sucesso'
                })

                setTimeout(() => {
                  this.$router.push({
                    path: '/cupons-desconto/lista'
                  })
                }, 1000)
              }
            })
            .catch((error) => {
              this.$bus.$emit('show-alert-chip', {
                message: error.message
              })
            })
        }
      } else {
        /** Se é criação de novos cupons em massa */
        if (this.isCreation) {
          /** Seta que está carregando o csv */
          this.uploadingCsv = true
        }

        /** Se for um cadastro de um novo cupom em massa */
        const fieldsFD = new FormData()
        const method = this.isCreation ? 'createLots' : 'updateLots'

        /** Obrigatórios */
        fieldsFD.append('nome', this.fields.cupom)
        if (this.isCreation) {
          fieldsFD.append('arquivoCupons', this.uploadedFile)
        } else {
          fieldsFD.append('codigo', this.couponId)
        }
        fieldsFD.append('tipoValor', this.fields.tipoValor.value)
        fieldsFD.append('valor', this.fields.valor)
        fieldsFD.append('ativo', this.fields.ativo)
        fieldsFD.append('centralReservas', this.fields.centralReservas)

        /** Opcionais */
        const apiParamNames = {
          valorMinimoQuartos: 'valorMinimoQuartos',
          minimoNoites: 'minimoNoites',
          minimoQuartos: 'minimoQuartos',
          tipoLimiteUso: 'tipoLimiteUso',
          quantidadeMaximaUso: 'quantidadeMaximaUso'
        }

        for (const paramName in apiParamNames) {
          if (this.fields[paramName]) {
            fieldsFD.append(apiParamNames[paramName], this.fields[paramName])
          }
        }

        if (this.fields.tipoValor.value === 3) {
          fieldsFD.append(
            'tipoNoiteGratisCupomDesconto',
            this.fields.tipoNoiteGratis.value
          )
        }

        /** Verificar se há alguma tarifa selecionada */
        const ratesCodes = this.formatRatesToSave(this.fields.tarifas)

        if (ratesCodes.length) {
          ratesCodes.forEach((code) => {
            fieldsFD.append('tarifas', code)
          })
        } else {
          this.allActiveRates.forEach((rate) => {
            fieldsFD.append('tarifas', rate.codigo)
          })
        }

        if (this.fields.periodoReserva) {
          fieldsFD.append(
            'reservaInicio',
            formatDate(
              this.fields.periodoReserva.start,
              'yyyy-MM-dd',
              typeof this.fields.periodoReserva.start !== 'object'
            )
          )

          fieldsFD.append(
            'reservaFim',
            formatDate(
              this.fields.periodoReserva.end,
              'yyyy-MM-dd',
              typeof this.fields.periodoReserva.end !== 'object'
            )
          )
        }

        if (this.fields.periodoHospedagem) {
          fieldsFD.append(
            'dataChegada',
            formatDate(
              this.fields.periodoHospedagem.start,
              'yyyy-MM-dd',
              typeof this.fields.periodoHospedagem.start !== 'object'
            )
          )
          fieldsFD.append(
            'dataSaida',
            formatDate(
              this.fields.periodoHospedagem.end,
              'yyyy-MM-dd',
              typeof this.fields.periodoHospedagem.end !== 'object'
            )
          )
        }

        this.$coupon[method](fieldsFD)
          .then((response) => {
            if (response.status === 200) {
              /** Habilita o save novamente */
              this.uploadingCsv = false

              this.$bus.$emit('show-alert-chip', {
                message:
                  'Processando cupons. Você será notificado quando estiver disponível para uso.'
              })

              setTimeout(() => {
                this.$router.push({
                  path: '/cupons-desconto/lista'
                })
              }, 2000)
            }
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages
            })

            /** Habilita o save novamente */
            this.uploadingCsv = false
            /** Remove o alerta se necessário */
            this.showUploadDelayAlert = false
          })

        this.showAlertModal = false
      }
    },

    /**
     * Preenche os campos na edição do cupom
     * com os valores previamente salvos
     *
     * @param {JSON} response - Resposta retornada pela api
     */
    fillEditionFields(response) {
      /** Formatar os dados para o select de tarifas */
      this.ratesSelectOptions.forEach((item) => {
        const options = []
        const filteredList = item.options

        filteredList.forEach((rate) => {
          /**
           * Validar se a tarifa deve ser adicionada na listagem
           * Se a opção possuir status ativo OU o cupom possuir essa tarifa vinculada
           */
          if (rate.ativo || response.data.tarifas.includes(rate.codigo)) {
            options.push(rate)
          }
        })

        item.options = options
      })

      /** Seta o tipo de desconto  */
      this.fields.tipoValor = this.discountTypeSelectOptions.find(
        (item) => item.value === this.fields.tipoValor
      )

      /** Seta as tarifas selecionadas  */
      this.fields.tarifas = this.ratesSelectOptions.reduce((acc, curr) => {
        const found = curr.options.filter((item) =>
          this.fields.tarifas.includes(item.codigo)
        )

        if (found) acc = [...acc, ...found]

        return acc
      }, [])

      this.fields.tipoNoiteGratis = this.typeOfUseOptions.find(
        (item) => +item.value === +this.fields.tipoNoiteGratis
      )

      /** Trata as datas selecionadas */
      if (response.data.reservaInicio) {
        this.minDate =
          new Date(response.data.reservaInicio) < this.minDate
            ? new Date(response.data.reservaInicio)
            : this.minDate
        this.fields.periodoReserva = {
          start: response.data.reservaInicio,
          end: response.data.reservaFim
        }
      }

      if (response.data.dataChegada) {
        this.minDate =
          new Date(response.data.dataChegada) < this.minDate
            ? new Date(response.data.dataChegada)
            : this.minDate
        this.fields.periodoHospedagem = {
          start: response.data.dataChegada,
          end: response.data.dataSaida
        }
      }

      const activeRates = response.data.tarifas.filter((item) => {
        return this.ratesSelectOptions
          .flatMap((item) => item.options)
          .some((rate) => item.codigo === rate.codigo)
      })

      if (activeRates.length !== response.data.tarifas.length) {
        this.rateStatus = true
      }
    },

    applySelectDataFormat(hotels) {
      hotels.forEach((hotel) => {
        hotel.options = []

        /**
         * Adiciona as opções de tarifas,
         * apenas desabilitando as inativas e que não permitem edição
         */
        hotel.tarifas.forEach((rate) => {
          /** Se for criação e a tarifa não estiver ativa, não adiciona */
          if (!this.couponId && !rate.ativo) return

          rate.disabled = rate.permiteEdicao === false || !rate.ativo

          hotel.options.push(rate)
          this.ratesId.push(rate.codigo) /** Listagem de ids das tarifas */
        })

        /** Se existe tarifas para o hotel */
        if (hotel.options.length > 0) this.ratesSelectOptions.push(hotel)
      })
    },

    /** Voltar para a listagem de cupons */
    goToList() {
      /** Esconder modal */
      this.showUploadDelayAlert = false
      /** Redirecionamento */
      this.$router.push({
        path: '/cupons-desconto/lista'
      })
    },

    /** Permitir apenas números positivos */
    onlyPositiveNumbers() {
      const value = parseInt(this.fields.quantidadeMaximaUso, 10)

      if (isNaN(value) || value < 0) {
        this.fields.quantidadeMaximaUso = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.fieldset {
  & + & {
    padding-top: 30px;
    border-top: 1px solid $gray-border;
  }
}

.heading {
  &__margin {
    margin-bottom: 20px;
  }

  &__margin-2 {
    margin-bottom: 35px;
  }

  &__margin-title {
    color: #474747;
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 20px;
  }

  &__margin-subtitle {
    font-size: 12px;
    margin-bottom: 30px;
  }

  &__advice {
    margin-top: 10px;
    color: $blue;
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
  }
}

.status-fields {
  display: flex;
  justify-content: flex-start;

  &--input {
    margin-right: 25px;
  }
}

.status-feedback {
  margin-top: 10px;
  font-size: font-size('size-small');
  color: $blue;
}

.fields-row {
  margin-bottom: 30px;

  &__mb50 {
    margin-bottom: 50px;
  }
}

.setup {
  .fields-row {
    margin-bottom: 40px;
  }
}

.page-actions {
  &--heading {
    margin-bottom: 15px;
  }

  &--button {
    cursor: pointer;
    & + & {
      margin-top: 10px;
    }
  }

  &--footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 45px;
  }
}
.text-modal {
  color: #474747;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 15px;
}

.input-file {
  margin-top: 30px;
}

.alert {
  &--inactivatedRates {
    font-size: 12px;
    color: #e0414b;
    position: absolute;
    margin-top: 5px;
  }
}
.loader {
  margin: {
    top: 40px;
    bottom: 20px;
  }
}
</style>
